// Implements: F-MCK-017, F-UIX-009, F-UIX-010
/** The trash pages, under `["mockups","trash"]`, paged exactly like the gallery. */

import { useInfiniteQuery } from "@tanstack/react-query";
import type { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { MOCKUPS_TRASH_KEY } from "../../../shared/api/queryKeys";
import type { TrashPageView } from "../../../types/api";
import { fetchTrashPage } from "../api/mockupsApi";

export type UseTrashResult = UseInfiniteQueryResult<InfiniteData<TrashPageView>, ApiError>;

export function useTrash(): UseTrashResult {
  return useInfiniteQuery<
    TrashPageView,
    ApiError,
    InfiniteData<TrashPageView>,
    typeof MOCKUPS_TRASH_KEY,
    string | undefined
  >({
    queryKey: MOCKUPS_TRASH_KEY,
    queryFn: ({ pageParam }) => fetchTrashPage(pageParam),
    initialPageParam: undefined,
    getNextPageParam: (last) => last.next_cursor ?? undefined,
  });
}
